import React, {useRef, useEffect} from "react";
import {Navigate, Routes, Route, useLocation} from "react-router";
import {useSelector} from "react-redux";
import AdminNavbar from "../components/Navbars/AppNavbar.jsx";
import Back from "../components/Navbars/components/Back";
import Sidebar from "../components/Sidebar/Sidebar";
import "./App.scss";
import {routes} from "../routes.js";
import ProtectedRoute from "../helpers/ProtectedRoute";

const AppLayout = () => {
  const mainContentRef = useRef();
  const location = useLocation();
  const theme = useSelector((state) => state.theme);

  useEffect(() => {
    if (document.documentElement.scrollTop !== undefined) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
    }

    if (mainContentRef.current?.scrollTop !== undefined) {
      mainContentRef.current.scrollTop = 0;
    }
  }, []);

  const getRoutes = (routes) => {
    return routes
      .filter((route) => route.layout === "/app")
      .map((route, index) => (
        <Route
          key={index}
          path={route.path}
          element={<ProtectedRoute component={route.component} />}
        />
      ));
  };

  const pathSegments = location.pathname.split("/").filter(Boolean);
  const currentRoute = pathSegments[1] || "home";

  return (
    <div data-theme={theme.name}>
      <Sidebar />
      <div className="admin-navbar-container">
        <AdminNavbar brandText={currentRoute} brandRoute={`/app/${currentRoute}`} />
      </div>
      <div className="main-content" ref={mainContentRef}>
        {currentRoute !== "home" && (
          <div className="back-button">
            <Back />
          </div>
        )}
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/app/home" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default AppLayout;
